import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.914 11.9l.11.11c-1.904 1.905-5.918.978-8.965-2.069C.012 6.894-.915 2.88.989.975l.111.11c.15-.294.343-.563.58-.8l1.379 1.38c-.971.971-.313 3.825 2.069 6.207 2.382 2.382 5.236 3.04 6.207 2.07l1.38 1.378a3.145 3.145 0 0 1-.8.58zM4.438 3.044L1.68 5.804.3 4.423l2.07-2.07L.99.976l.69-.69a.975.975 0 0 1 1.379 0l1.38 1.38c.38.38.38.998 0 1.38zm5.518 5.518a.975.975 0 0 1 1.379 0l1.38 1.38c.38.38.38.998 0 1.378l-.69.69-1.38-1.38-2.069 2.07-1.38-1.38 2.76-2.758z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-phone"}) } }